import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { SuppliersPage } from '@/pages/suppliers/SuppliersPage'
import { GRNPage } from '@/pages/grn/GRNPage'

const TAB_SUPPLIERS = 'suppliers'
const TAB_GRN = 'grn'

export const ProcurementPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') === TAB_GRN ? TAB_GRN : TAB_SUPPLIERS

  const setTab = (value: string) => {
    setSearchParams({ tab: value })
  }

  return (
    <div className="w-full">
      <div className="mb-6">
        <h1 className="text-3xl font-bold esales-text font-display">Procurement</h1>
        <p className="text-muted-foreground mt-1">Suppliers and goods receiving</p>
      </div>

      {/* Tabs - active tab uses same style as Add Supplier (glow-button) */}
      <div className="flex gap-1 p-1 rounded-xl bg-muted/30 border border-border/50 w-fit mb-6">
        <button
          type="button"
          onClick={() => setTab(TAB_SUPPLIERS)}
          className={tab === TAB_SUPPLIERS ? 'glow-button px-5 py-2.5 text-sm rounded-lg' : 'px-5 py-2.5 rounded-lg text-sm font-semibold text-muted-foreground hover:text-foreground transition-all'}
        >
          Suppliers
        </button>
        <button
          type="button"
          onClick={() => setTab(TAB_GRN)}
          className={tab === TAB_GRN ? 'glow-button px-5 py-2.5 text-sm rounded-lg' : 'px-5 py-2.5 rounded-lg text-sm font-semibold text-muted-foreground hover:text-foreground transition-all'}
        >
          GRN
        </button>
      </div>

      {/* Tab content */}
      <div className="min-h-[400px]">
        {tab === TAB_SUPPLIERS && <SuppliersPage embedded />}
        {tab === TAB_GRN && <GRNPage embedded />}
      </div>
    </div>
  )
}
